import React from "react";
import cn from "classnames";
import { buttonVariants } from "theme/buttonVariants";
import { CallbirdButton } from "components/CallbirdButton";

const InfoPanelComponent = ({
    state: {
        url = "",
        mobileUrl = "",
        displayOrder = "image-text",
        infoPanelHeading = "Heading",
        infoPanelText = "",
        infoPanelPrimaryButtonText = "",
        infoPanelPrimaryButtonLink = "",
        infoPanelPrimaryButtonColour = "primary",
        infoPanelSecondaryButtonText = "",
        infoPanelSecondaryButtonLink = "",
        infoPanelSecondaryButtonColour = "transparent",
        showCallbirdButton = false,
    },
}) => {
    return (
        <div className="flex flex-col lg:flex-row max-w-[960px] mx-auto gap-[30px]">
            <div
                className={cn(
                    "flex-1",
                    displayOrder === "image-text"
                        ? "order-1"
                        : "order-1 lg:order-2",
                )}
            >
                <img
                    src={url}
                    alt={infoPanelHeading}
                    className={cn("w-full h-full object-cover rounded-[10px]", {
                        "hidden lg:block": !!mobileUrl,
                    })}
                />

                {mobileUrl && (
                    <img
                        src={mobileUrl}
                        alt={infoPanelHeading}
                        className={
                            "w-full h-full object-cover rounded-[10px] block lg:hidden"
                        }
                    />
                )}
            </div>
            <div
                className={cn(
                    "flex-1",
                    displayOrder === "image-text"
                        ? "order-2"
                        : "order-2 lg:order-1",
                )}
            >
                {infoPanelHeading && (
                    <h2 className="text-[24px] leading-[30px] text-center lg:!text-left lg:!text-[30px] lg:!leading-[36px] font-extrabold mb-[15px]">
                        {infoPanelHeading}
                    </h2>
                )}
                {infoPanelText && (
                    <div
                        className="text-brand-black"
                        dangerouslySetInnerHTML={{ __html: infoPanelText }}
                    />
                )}
                {showCallbirdButton && <CallbirdButton />}
                <div className="flex gap-[10px] mt-[15px] flex-col lg:flex-row items-center lg:items-start">
                    {infoPanelPrimaryButtonLink && (
                        <a
                            href={infoPanelPrimaryButtonLink}
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            className={cn(
                                buttonVariants[infoPanelPrimaryButtonColour],
                                "!no-underline !hover:font-bold !font-bold !w-full lg:!w-auto",
                            )}
                        >
                            {infoPanelPrimaryButtonText}
                        </a>
                    )}

                    {infoPanelSecondaryButtonLink && (
                        <a
                            href={infoPanelSecondaryButtonLink}
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            className={cn(
                                buttonVariants[infoPanelSecondaryButtonColour],
                                "!no-underline !hover:font-bold !font-bold !w-full lg:!w-auto",
                            )}
                        >
                            {infoPanelSecondaryButtonText}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InfoPanelComponent;
